import { MenuType } from "../../redux/userManagement/userManagementTypes";
import Checkbox from '../commons/Checkbox';

type AppProps = {
  menuDetails: MenuType,
  selectedMenus: any[];
  handleSelectMenu: (menuId: number) => void;
  disabled?: boolean;
}

const NormalMenuList = ({
  menuDetails,
  selectedMenus,
  handleSelectMenu,
  disabled
}: AppProps) => {
  return (
    <div className="col-md-4">
      <div className="d-flex p-2">
        <Checkbox
          onPress={() => handleSelectMenu(menuDetails?.menu_id)}
          checked={selectedMenus?.includes(menuDetails?.menu_id)}
        // disabled={!!menuDetails?.coming_soon}
        />
        <p className="ml-2 mb-0">{menuDetails?.menu_name}</p>
      </div>
    </div>
  )
};

export default NormalMenuList